(function($, utils, ga) {

  var MAX_SAFE_INTEGER = (Number.MAX_SAFE_INTEGER || 9007199254740991) - 1,
      GA_CATEGORY = 'bigfoot_slideview';

  /**
   * Builds a URL fragment that contains div params for each ad placeholder.
   * @param {Object} data A collection of ad data.
   * @returns {String} A URL fragment of div params. E.g. '&div=dom-id-1&div=dom-id-2'
   */
  function generatePlaceholdersUrlFragment(data) {
    return data.reduce(function(fragment, item) {
      return fragment + '&div=' + item.id;
    }, '');
  }

  /**
   * Displays ad content fetched using the script and fires off impression events.
   * @param {Object} ads A collection of ad data.
   */
  function displayAds(ads) {

    // This object is created when the ad script executes. Let's make sure it actually exists first.
    if (window.liAds) {
      window.liAds.display();

      // Show each and and fire off impression events.
      ads.forEach(function(ad) {
        var $ad = $('#' + ad.id);
        if (!$ad.is(':empty')) {
          ga(GA_CATEGORY, 'sponsored_content_related_impression_' + ad.position);
          $ad.parent('.related-ad').show();
        }
      });
    }
  }

  /**
   * Creates a script element with a source generated from the passed ad data.
   * @param {Object} data Ad data and a URL endpoint for fetching content.
   * @returns {Element} The generated script element.
   */
  function generateScript(data) {

    var placeholders = data.placeholders,
        script = document.createElement('script'),
        random = Math.random() * MAX_SAFE_INTEGER,
        urlFragment = generatePlaceholdersUrlFragment(placeholders);

    script.src = data.url + '?random=' + random + urlFragment + '&style=false';
    script.onload = displayAds.bind(null, placeholders);

    return script;
  }

  /**
   * Loads sponsored ads given a collection of DOM nodes to populate, their positions,
   * and a URL for retrieving the ad content.
   * @param {jQuery} $el A jQuery'd element that contains the ads.
   * @param {Object} data An object containing DOM and URL information.
   * @constructor
   */
  function SponsoredContent($el, data) {

    // Generate the script tag for requesting ad data and append it to the body.
    document.body.appendChild(generateScript(data));

    // Configure a click listener delegated to ad content elements for tracking.
    $el.on('click', '.ad-content', function() {
      ga(GA_CATEGORY, 'sponsored_content_related_click_' + this.getAttribute('data-position'));
    });
  }

  utils.exports('slideview.SponsoredContent', SponsoredContent);

}(
  window.jQuery,
  slideshare_object.utils,
  slideshare_object.ga
));
